import { memo, useCallback } from 'react';
import { ListRenderItem } from 'react-native';
import { selectAuthenticationStatus, useSelector } from '@bonanza-social/toolkit/state';
import { Box, List } from '@bonanza-social/moonlight';
import {
  selectCategoriesState,
  selectGamesState,
  selectLobbyCategoryIds,
} from '../../state';
import GamesRandomizer from '../GamesRandomizer/GamesRandomizer';
import GamesScreenSkeleton from '../../screens/GamesScreen/GamesScreenSkeleton';
import CategoriesHeader from './Header/CategoriesHeader';
import Category from './Category/Category';
import AllGamesBanner from '../AllGames/AllGamesBanner';

function Categories() {
  const categoryIds = useSelector(selectLobbyCategoryIds);
  const categoriesState = useSelector(selectCategoriesState);
  const authStatus = useSelector(selectAuthenticationStatus);

  const gamesState = useSelector(selectGamesState);
  const randomizerIndex = Math.min(
    categoryIds.indexOf(0) !== -1 ? 6 : 5,
    categoryIds.length - 1,
  );

  const renderItem = useCallback<ListRenderItem<(typeof categoryIds)[number]>>(
    ({ item, index }) => (
      <>
        <Category categoryId={item} />
        {index === randomizerIndex && authStatus === 'authenticated' && (
          <GamesRandomizer margin="space-400" marginBottom="space-100" />
        )}
      </>
    ),
    [randomizerIndex, authStatus],
  );

  const renderSeparator = useCallback(() => <Box height="space-300" />, []);

  if (categoriesState === 'rejected' || gamesState === 'rejected') {
    // TODO return proper component
    return null;
  }

  return (
    <List
      data={categoryIds}
      windowSize={2}
      ListHeaderComponent={CategoriesHeader}
      ListFooterComponent={AllGamesBanner}
      ListEmptyComponent={GamesScreenSkeleton}
      ItemSeparatorComponent={renderSeparator}
      renderItem={renderItem}
    />
  );
}

export default memo(Categories);
